// /schedules 상태 코드 → 라벨 / 색 매핑 (route-local 도메인 지식).

import type { StatusChipColor } from "components/list";

interface StatusMeta {
  label: string;
  color: StatusChipColor;
}

// 시설 방문 상태(complete)
export const completeMeta: Record<string, StatusMeta> = {
  incomplete: { label: "배정", color: "default" },
  confirm: { label: "시설수락", color: "primary" },
  cancel: { label: "취소", color: "error" },
  complete: { label: "완료", color: "success" },
};

// 현장요원 수락(accept)
export const acceptMeta: Record<string, StatusMeta> = {
  WAITING: { label: "미확인", color: "warning" },
  REJECT: { label: "거절", color: "error" },
  ACCEPT: { label: "수락", color: "success" },
};

// 매핑에 없는 값도 안전하게 표시
export const resolveStatusMeta = (
  map: Record<string, StatusMeta>,
  value: unknown
): StatusMeta => {
  const key = value === null || value === undefined ? "" : String(value);
  return map[key] ?? { label: key || "-", color: "default" };
};
